import Common from '../common/CommonPowerbook';

class TmplObjectMaking {

    constructor() {
        this.comm = Common.instance;
    }


     make(_d){
         return `
<section class="object object-recipe">
    <header class="object__header">
        <img class="object__icon" src="${this.comm.staticImgURL}/powerbook/lineage/${_d.image}" alt="">
        <span class="object__name"><a class="item-grade--1" href="${this.comm.powerbookURL}/${_d.name}">${_d.name}</a></span>
    </header>
    <div class="object__attribute">
        <header class="object-stuff__handler">총 재료</header>
        <article class="object-stuff" style="display: none;">
            <strong>총 재료</strong>
            ${this.total(_d.totalStuff)}
        </article>
    </div>
    
    <div class="object__itemlist">			
        ${this.getTree(_d.stuff)}
        <button class="btn-toggle off"></button>
    </div>
</section>`
     }

    total(_d){
         let list = '';
         for( let i in _d){
             list += `<a href="${this.comm.powerbookURL}/${i}">${i}</a> : ${_d[i]}<br>`;
         }
         return list;
    }


    getTree(_d, _isSub){
        let list = _d.map( item => {
            let me = `
<li>
    <img class="object__icon" src="${this.comm.staticImgURL}/powerbook/lineage/${item.image}" alt="">
    <span class="object__name"><a class="item-grade--1" href="${this.comm.powerbookURL}/${item.name}">${item.name}</a> ${item.quantity}개 </span>
    ${(!!item.stuff && !!item.stuff.length)? `<span class="bullet plus"></span>`:''}
    ${(!!item.stuff && !!item.stuff.length)? this.getTree(item.stuff, true): ''}
</li>`;
            return me;
        }).join(' ');

        return `<ul${_isSub?` style="display: none"`:' class="first-list"'}>${list}</ul>`;
    }



}
export default TmplObjectMaking;


// WEBPACK FOOTER //
// ./lineage/TmplObjectMaking.js